module.exports = __webpack_public_path__ + "img/glz-w.82e6c86d.png";